import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`locale-changer flex py-3 ${!_ctx.landingPage && 'border-b-[1px]'}`)
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "radio",
      id: "en",
      value: "en",
      name: "radio",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event))
    }, null, 512), [
      [_vModelRadio, _ctx.$i18n.locale]
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("label", { for: "en" }, "EN", -1)),
    _cache[3] || (_cache[3] = _createTextVNode(" | ")),
    _withDirectives(_createElementVNode("input", {
      type: "radio",
      id: "de",
      value: "de",
      name: "radio",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$i18n.locale) = $event))
    }, null, 512), [
      [_vModelRadio, _ctx.$i18n.locale]
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("label", { for: "de" }, "DE", -1))
  ], 2))
}